import { getTxtIdMapperPath } from "../../router/txtIdMapper";
import { apiS, apiS_fileDownload } from "./api-base";
import { getESGReqHeader } from "./tool-service";

//F1010201 組織邊界查詢
export const getCompanyPlaceList = async () => {
  let ReqBody = {
    ReqHeader: getESGReqHeader("F1010201"),
    ReqBody: {},
  };
  return await apiS({ url: `/${getTxtIdMapperPath("F1010201")}`, method: "post", data: ReqBody });
};

// 碳盤查計畫查詢
export const getCarbonPlanList = async (reqBody) => {
  let ReqBody = {
    ReqHeader: getESGReqHeader("F1010301"),
    ReqBody: reqBody,
  };
  return await apiS({ url: `/${getTxtIdMapperPath("F1010301")}`, method: "post", data: ReqBody });
};

// 盤查計畫組織邊界查詢
export const getPlanOrganizationalBoundaryList = async (reqBody) => {
  let ReqBody = {
    ReqHeader: getESGReqHeader("F101030101"),
    ReqBody: reqBody,
  };
  return await apiS({ url: `/${getTxtIdMapperPath("F101030101")}`, method: "post", data: ReqBody });
};

//碳盤查計畫新增
export const createCarbonPlan = async (reqBody) => {
  let ReqBody = {
    ReqHeader: getESGReqHeader("F1010302"),
    ReqBody: reqBody,
  };
  return await apiS({ url: `/${getTxtIdMapperPath("F1010302")}`, method: "post", data: ReqBody });
};

//碳盤查計畫新增Before
export const F1010302Before = async () => {
  let ReqBody = {
    ReqHeader: getESGReqHeader("F1010302"),
    ReqBody: {},
  };
  return await apiS({ url: `/${getTxtIdMapperPath("F1010302", true)}`, method: "post", data: ReqBody });
};

//碳盤查計畫編輯
export const updateCarbonPlan = async (reqBody) => {
  let ReqBody = {
    ReqHeader: getESGReqHeader("F1010303"),
    ReqBody: reqBody,
  };
  return await apiS({ url: `/${getTxtIdMapperPath("F1010303")}`, method: "post", data: ReqBody });
};

//碳盤查計畫刪除
export const deleteCarbonPlan = async (reqBody) => {
  let ReqBody = {
    ReqHeader: getESGReqHeader("F1010304"),
    ReqBody: reqBody,
  };
  return await apiS({ url: `/${getTxtIdMapperPath("F1010304")}`, method: "post", data: ReqBody });
};

//新增組織邊界 FormData格式 f1010311
export const createOrgCriterion = async (formData) => {
  return await apiS({ url: `/${getTxtIdMapperPath("F1010311")}`, method: "post", data: formData });
};

//更新組織邊界 FormData格式 f1040203
export const updatePlaces = async (formData) => {
  return await apiS({ url: `/${getTxtIdMapperPath("F1040203")}`, method: "post", data: formData });
};

//新增組織邊界 統一檢核
export const F1010311Before = async () => {
  let ReqBody = {
    ReqHeader: getESGReqHeader("F1010311"),
    ReqBody: {},
  };
  return await apiS({ url: `/${getTxtIdMapperPath("F1010311", true)}`, method: "post", data: ReqBody });
};

//新增組織邊界 統一檢核
export const F1010312Before = async () => {
  let ReqBody = {
    ReqHeader: getESGReqHeader("F1010312"),
    ReqBody: {},
  };
  return await apiS({ url: `/${getTxtIdMapperPath("F1010312", true)}`, method: "post", data: ReqBody });
};

//更新計畫組織邊界
export const UpdatePlanOrgPlaceSeq = async (reqBody) => {
  let ReqBody = {
    ReqHeader: getESGReqHeader("F1010312"),
    ReqBody: reqBody,
  };
  return await apiS({ url: `/${getTxtIdMapperPath("F1010312")}`, method: "post", data: ReqBody });
};

//建立前排放源鑑別查詢
export const queryIdentifyDetailList = async (reqBody) => {
  let ReqBody = {
    ReqHeader: getESGReqHeader("F1010320"),
    ReqBody: reqBody,
  };
  return await apiS({ url: `/${getTxtIdMapperPath("F1010320")}`, method: "post", data: ReqBody });
};

//排放源鑑別查詢
export const queryPlanClassList = async (reqBody) => {
  let ReqBody = {
    ReqHeader: getESGReqHeader("F1010321"),
    ReqBody: reqBody,
  };
  return await apiS({ url: `/${getTxtIdMapperPath("F1010321")}`, method: "post", data: ReqBody });
};

//排放源鑑別範疇/類別 criterion 0-> S ; criterion 1 -> C
export const queryClassProcessList = async (reqBody) => {
  let ReqBody = {
    ReqHeader: getESGReqHeader("F1010325"),
    ReqBody: reqBody,
  };
  return await apiS({ url: `/${getTxtIdMapperPath("F1010325")}`, method: "post", data: ReqBody });
};

//排放源型式 classNo by F1010325
export const queryClassNoTypeList = async (reqBody) => {
  let ReqBody = {
    ReqHeader: getESGReqHeader("F1010326"),
    ReqBody: reqBody,
  };
  return await apiS({ url: `/${getTxtIdMapperPath("F1010326")}`, method: "post", data: ReqBody });
};

//設備查詢
export const querySubTypeDeviceList = async (reqBody) => {
  let ReqBody = {
    ReqHeader: getESGReqHeader("F1010327"),
    ReqBody: reqBody,
  };
  return await apiS({ url: `/${getTxtIdMapperPath("F1010327")}`, method: "post", data: ReqBody });
};

//設備新增
export const CreateSubTypeDevice = async (reqBody) => {
  let ReqBody = {
    ReqHeader: getESGReqHeader("F1010328"),
    ReqBody: reqBody,
  };
  return await apiS({ url: `/${getTxtIdMapperPath("F1010328")}`, method: "post", data: ReqBody });
};

//設備新增 統一檢核
export const F1010328Before = async () => {
  let ReqBody = {
    ReqHeader: getESGReqHeader("F1010328"),
    ReqBody: {},
  };
  return await apiS({ url: `/${getTxtIdMapperPath("F1010328", true)}`, method: "post", data: ReqBody });
};

//排放源查詢
export const queryTypeSubTypeSourceList = async (reqBody) => {
  let ReqBody = {
    ReqHeader: getESGReqHeader("F1010329"),
    ReqBody: reqBody,
  };
  return await apiS({ url: `/${getTxtIdMapperPath("F1010329")}`, method: "post", data: ReqBody });
};

//排放源鑑別新增 改用formData傳 f1010322
export const CreateIdentifyInfo = async (formData) => {
  return await apiS({ url: `/${getTxtIdMapperPath("F1010322")}`, method: "post", data: formData });
};

//排放源鑑別新增 統一檢核
export const F1010322Before = async () => {
  let ReqBody = {
    ReqHeader: getESGReqHeader("F1010322"),
    ReqBody: {},
  };
  return await apiS({ url: `/${getTxtIdMapperPath("F1010322", true)}`, method: "post", data: ReqBody });
};

//排放源鑑別更新 改為 formData格式 f1010323
export const updateIdentifyInfo = async (formData) => {
  return await apiS({ url: `/${getTxtIdMapperPath("F1010323")}`, method: "post", data: formData });
};

//排放源鑑別刪除
export const deleteIdentifyItem = async (reqBody) => {
  let ReqBody = {
    ReqHeader: getESGReqHeader("F1010324"),
    ReqBody: reqBody,
  };
  return await apiS({ url: `/${getTxtIdMapperPath("F1010324")}`, method: "post", data: ReqBody });
};

//活動數據查詢 F1010331
export const queryActivityClassList = async (reqBody) => {
  let ReqBody = {
    ReqHeader: getESGReqHeader("F1010331"),
    ReqBody: reqBody,
  };
  return await apiS({ url: `/${getTxtIdMapperPath("F1010331")}`, method: "post", data: ReqBody });
};

//活動數據新增 F1010332
export const CreateActivityDataList = async (reqBody) => {
  let ReqBody = {
    ReqHeader: getESGReqHeader("F1010332"),
    ReqBody: reqBody,
  };
  return await apiS({ url: `/${getTxtIdMapperPath("F1010332")}`, method: "post", data: ReqBody });
};

//活動數據新增 統一檢核 F1010332
export const F1010332Before = async (reqBody) => {
  let ReqBody = {
    ReqHeader: getESGReqHeader("F1010332"),
    ReqBody: reqBody,
  };
  return await apiS({ url: `/${getTxtIdMapperPath("F1010332", true)}`, method: "post", data: ReqBody });
};

//活動數據更新 F1010332
export const updateActivityDataList = async (reqBody) => {
  let ReqBody = {
    ReqHeader: getESGReqHeader("F1010333"),
    ReqBody: reqBody,
  };
  return await apiS({ url: `/${getTxtIdMapperPath("F1010333")}`, method: "post", data: ReqBody });
};

//活動數據刪除 F1010332
export const DeleteActivityData = async (reqBody) => {
  let ReqBody = {
    ReqHeader: getESGReqHeader("F1010334"),
    ReqBody: reqBody,
  };
  return await apiS({ url: `/${getTxtIdMapperPath("F1010334")}`, method: "post", data: ReqBody });
};

//排放量計算查詢
export const queryEmissionsCalList = async (reqBody) => {
  let ReqBody = {
    ReqHeader: getESGReqHeader("F1010341"),
    ReqBody: reqBody,
  };
  return await apiS({ url: `/${getTxtIdMapperPath("F1010341")}`, method: "post", data: ReqBody });
};

//排放量計算新增 改用formData f1010342
export const createCustomEmissions = async (formData) => {
  return await apiS({ url: `/${getTxtIdMapperPath("F1010342")}`, method: "post", data: formData });
};

//排放量計算新增 統一檢核
export const F1010342Before = async () => {
  let ReqBody = {
    ReqHeader: getESGReqHeader("F1010342"),
    ReqBody: {},
  };
  return await apiS({ url: `/${getTxtIdMapperPath("F1010342", true)}`, method: "post", data: ReqBody });
};

//排放量計算編輯 改用formData f1010343
export const updateCustomEmissions = async (formData) => {
  return await apiS({ url: `/${getTxtIdMapperPath("F1010343")}`, method: "post", data: formData });
};

//排放量計算編輯 統一檢核
export const F1010343Before = async () => {
  let ReqBody = {
    ReqHeader: getESGReqHeader("F1010343"),
    ReqBody: {},
  };
  return await apiS({ url: `/${getTxtIdMapperPath("F1010343", true)}`, method: "post", data: ReqBody });
};

//排放量計算刪除
export const deleteCustomEmissions = async (reqBody) => {
  let ReqBody = {
    ReqHeader: getESGReqHeader("F1010344"),
    ReqBody: reqBody,
  };
  return await apiS({ url: `/${getTxtIdMapperPath("F1010344")}`, method: "post", data: ReqBody });
};

//上傳佐證資料 從formData 改一般API 方式打
export const uploadProvingData = async (reqBody) => {
  let ReqBody = {
    ReqHeader: getESGReqHeader("F1010335"),
    ReqBody: reqBody,
  };
  return await apiS({ url: `/${getTxtIdMapperPath("F1010335")}`, method: "post", data: ReqBody });
};

//上傳佐證資料 formData f1010335
export const uploadProvingDataByFormData = async (formData) => {
  return await apiS({ url: `/${getTxtIdMapperPath("F1010335")}`, method: "post", data: formData });
};

//下載佐證資料 download File responseType:'blob' //另外處理檔案部分
export const downloadProvingData = async (reqBody) => {
  let ReqBody = {
    ReqHeader: getESGReqHeader("F1010336"),
    ReqBody: reqBody,
  };
  return await apiS_fileDownload(
    { url: `/${getTxtIdMapperPath("F1010336")}`, method: "post", data: ReqBody, responseType: "blob" },
    false,
  );
};

//郵遞區號查詢
export const queryCountyList = async () => {
  let ReqBody = {
    ReqHeader: getESGReqHeader("F1010313"),
    ReqBody: {},
  };
  return await apiS({ url: `/${getTxtIdMapperPath("F1010313")}`, method: "post", data: ReqBody });
};

//原燃物料查詢
export const queryMaterialList = async () => {
  let ReqBody = {
    ReqHeader: getESGReqHeader("F1010330"),
    ReqBody: {},
  };
  return await apiS({ url: `/${getTxtIdMapperPath("F1010330")}`, method: "post", data: ReqBody });
};

//下載清冊
export const downloadTemplateExcel = async (reqBody) => {
  let ReqBody = {
    ReqHeader: getESGReqHeader("F1010351"),
    ReqBody: reqBody,
  };
  return await apiS(
    { url: `/${getTxtIdMapperPath("F1010351")}`, method: "post", data: ReqBody, responseType: "blob" },
    false,
    true,
  );
};
export const downloadNewTemplateExcel = async (reqBody) => {
  let ReqBody = {
    ReqHeader: getESGReqHeader("F101035101"),
    ReqBody: reqBody,
  };
  return await apiS(
    { url: `/${getTxtIdMapperPath("F101035101")}`, method: "post", data: ReqBody, responseType: "blob" },
    false,
    true,
  );
};

export const downTemplate3Excel = async (reqBody) => {
  let ReqBody = {
    ReqHeader: getESGReqHeader("F101035102"),
    ReqBody: reqBody,
  };
  return await apiS(
    { url: `/${getTxtIdMapperPath("F101035102")}`, method: "post", data: ReqBody, responseType: "blob" },
    false,
    true,
  );
};

export const downTemplate4Excel = async (reqBody) => {
  let ReqBody = {
    ReqHeader: getESGReqHeader("F101035103"),
    ReqBody: reqBody,
  };
  return await apiS(
    { url: `/${getTxtIdMapperPath("F101035103")}`, method: "post", data: ReqBody, responseType: "blob" },
    false,
    true,
  );
};

export const downTemplateByIndustryCategoryExcel = async (reqBody) => {
  let ReqBody = {
    ReqHeader: getESGReqHeader("F101035104"),
    ReqBody: reqBody,
  };
  return await apiS(
    { url: `/${getTxtIdMapperPath("F101035104")}`, method: "post", data: ReqBody, responseType: "blob" },
    false,
    true,
  );
};

//下載報告書
export const esgReportBuilder = async (reqBody) => {
  let ReqBody = {
    ReqHeader: getESGReqHeader("F1010352"),
    ReqBody: reqBody,
  };
  return await apiS({ url: `/${getTxtIdMapperPath("F1010352")}`, method: "post", data: ReqBody });
};

//盤查報告清單查詢
export const esgReportList = async (reqBody) => {
  let ReqBody = {
    ReqHeader: getESGReqHeader("F1010361"),
    ReqBody: reqBody,
  };
  return await apiS({ url: `/${getTxtIdMapperPath("F1010361")}`, method: "post", data: ReqBody });
};

//產生報告書
export const createESGReport = async (reqBody) => {
  let ReqBody = {
    ReqHeader: getESGReqHeader("F1010362"),
    ReqBody: reqBody,
  };
  return await apiS({ url: `/${getTxtIdMapperPath("F1010362")}`, method: "post", data: ReqBody });
};

//報告書狀態查詢
export const queryReportStatus = async (reqBody) => {
  let ReqBody = {
    ReqHeader: getESGReqHeader("F1010365"),
    ReqBody: reqBody,
  };
  return await apiS({ url: `/${getTxtIdMapperPath("F1010365")}`, method: "post", data: ReqBody });
};

//報告書編輯 f1010363
export const modifyEsgReport = async (formData) => {
  return await apiS({ url: `/${getTxtIdMapperPath("F1010363")}`, method: "post", data: formData });
};

//報告書狀態查詢
export const deleteEsgReport = async (reqBody) => {
  let ReqBody = {
    ReqHeader: getESGReqHeader("F1010364"),
    ReqBody: reqBody,
  };
  return await apiS({ url: `/${getTxtIdMapperPath("F1010364")}`, method: "post", data: ReqBody });
};

// 重大性鑑別
export const queryImportantIndetification = async (reqBody) => {
  let ReqBody = {
    ReqHeader: getESGReqHeader("F1010305"),
    ReqBody: reqBody,
  };
  return await apiS({ url: `/${getTxtIdMapperPath("F1010305")}`, method: "post", data: ReqBody });
};

export const updateImportantIndetification = async (reqBody) => {
  let ReqBody = {
    ReqHeader: getESGReqHeader("F1010306"),
    ReqBody: reqBody,
  };
  return await apiS({ url: `/${getTxtIdMapperPath("F1010306")}`, method: "post", data: ReqBody });
};

export const checkImportantIndetificationItem = async (reqBody) => {
  let ReqBody = {
    ReqHeader: getESGReqHeader("F1010307"),
    ReqBody: reqBody,
  };
  return await apiS({ url: `/${getTxtIdMapperPath("F1010307")}`, method: "post", data: ReqBody });
};

export const copyPlanSn = async (reqBody) => {
  let ReqBody = {
    ReqHeader: getESGReqHeader("F1010308"),
    ReqBody: reqBody,
  };
  return await apiS({ url: `/${getTxtIdMapperPath("F1010308")}`, method: "post", data: ReqBody });
};

export const queryCopyPlanSnBatch = async (reqBody) => {
  let ReqBody = {
    ReqHeader: getESGReqHeader("F101030801"),
    ReqBody: reqBody,
  };
  return await apiS({ url: `/${getTxtIdMapperPath("F101030801")}`, method: "post", data: ReqBody });
};

export const downloadCarbonTemplateExcel = async (reqBody) => {
  let ReqBody = {
    ReqHeader: getESGReqHeader("f1010366"),
    ReqBody: reqBody,
  };
  return await apiS(
    { url: `/${getTxtIdMapperPath("f1010366")}`, method: "post", data: ReqBody, responseType: "blob" },
    false,
    true,
  );
};

export const importCarbonTemplateExcel = async (formData) => {
  return await apiS({ url: `/${getTxtIdMapperPath("f1010367")}`, method: "post", data: formData });
};

export const sortIdentificationItem = async (reqBody) => {
  let ReqBody = {
    ReqHeader: getESGReqHeader("f1010353"),
    ReqBody: reqBody,
  };
  return await apiS({ url: `/${getTxtIdMapperPath("f1010353")}`, method: "post", data: ReqBody });
};

// 清冊匯出任務建立（非同步）
export const createInventoryExportTask = async (reqBody) => {
  let ReqBody = {
    ReqHeader: getESGReqHeader("F1010372"),
    ReqBody: reqBody,
  };
  return await apiS({ url: `/${getTxtIdMapperPath("F1010372")}`, method: "post", data: ReqBody });
};

// 清冊匯出任務狀態查詢
export const queryInventoryExportTaskStatus = async (reqBody) => {
  let ReqBody = {
    ReqHeader: getESGReqHeader("F1010373"),
    ReqBody: reqBody,
  };
  return await apiS({ url: `/${getTxtIdMapperPath("F1010373")}`, method: "post", data: ReqBody });
};

// 清冊匯出任務下載
export const downloadInventoryExportTaskFile = async (reqBody) => {
  let ReqBody = {
    ReqHeader: getESGReqHeader("F1010374"),
    ReqBody: reqBody,
  };
  return await apiS(
    { url: `/${getTxtIdMapperPath("F1010374")}`, method: "post", data: ReqBody, responseType: "blob" },
    false,
    true,
  );
};

// 審核流程查詢
export const getApproveWorkFlowList = async (reqBody) => {
  let ReqBody = {
    ReqHeader: getESGReqHeader("F1010368"),
    ReqBody: reqBody,
  };
  return await apiS({ url: `/${getTxtIdMapperPath("F1010368")}`, method: "post", data: ReqBody });
};

// 簽核流程查詢
export const settingApproveWorkFlow = async (reqBody) => {
  let ReqBody = {
    ReqHeader: getESGReqHeader("F1010369"),
    ReqBody: reqBody,
  };
  return await apiS({ url: `/${getTxtIdMapperPath("F1010369")}`, method: "post", data: ReqBody });
};

// 簽核審核
export const approveWork = async (reqBody) => {
  let ReqBody = {
    ReqHeader: getESGReqHeader("F1010370"),
    ReqBody: reqBody,
  };
  return await apiS({ url: `/${getTxtIdMapperPath("F1010370")}`, method: "post", data: ReqBody });
};

// 簽核流程查詢
export const queryApproveHistory = async (reqBody) => {
  let ReqBody = {
    ReqHeader: getESGReqHeader("F1010371"),
    ReqBody: reqBody,
  };
  return await apiS({ url: `/${getTxtIdMapperPath("F1010371")}`, method: "post", data: ReqBody });
};
